export const infosettingConstants = {
    SET_INFOSETTINGS: 'SET_INFOSETTINGS',
};
